export interface OnboardingStep {
  id: number;
  label: string;
  icon: string;
  description: string;
}

export const onboardingSteps: OnboardingStep[] = [
  { id: 1, label: 'Datos básicos', icon: 'ri-radio-line', description: 'Nombre, categoría, ubicación y descripción de tu radio' },
  { id: 2, label: 'Stream URL', icon: 'ri-sound-module-line', description: 'Configura la fuente de streaming de tu emisora' },
  { id: 3, label: 'Logo y portada', icon: 'ri-palette-line', description: 'Subí el logo y la imagen de portada de tu radio' },
  { id: 4, label: 'Redes sociales', icon: 'ri-share-line', description: 'Conectá tus redes sociales para que te encuentren' },
  { id: 5, label: 'Cabina', icon: 'ri-chat-3-line', description: 'Configurá la moderación y el chat con oyentes' },
  { id: 6, label: 'Programación', icon: 'ri-calendar-2-line', description: 'Agregá los programas y horarios de tu grilla' },
  { id: 7, label: 'Publicar radio', icon: 'ri-rocket-line', description: 'Revisá todo y poné tu radio al aire' },
];

export interface ChecklistItem {
  id: string;
  label: string;
  icon: string;
  stepId: number;
  description: string;
}

export const checklistItems: ChecklistItem[] = [
  { id: 'stream', label: 'Stream configurado', icon: 'ri-sound-module-line', stepId: 2, description: 'URL de streaming funcionando' },
  { id: 'logo', label: 'Logo y branding', icon: 'ri-image-line', stepId: 3, description: 'Logo y portada subidos' },
  { id: 'profile', label: 'Perfil de radio', icon: 'ri-radio-line', stepId: 1, description: 'Nombre, categoría y ubicación' },
  { id: 'programs', label: 'Programas', icon: 'ri-calendar-2-line', stepId: 6, description: 'Al menos un programa en grilla' },
  { id: 'hosts', label: 'Locutores', icon: 'ri-mic-line', stepId: 6, description: 'Al menos un locutor asignado' },
  { id: 'social', label: 'Redes sociales', icon: 'ri-share-line', stepId: 4, description: 'Al menos una red vinculada' },
  { id: 'domain', label: 'Dominio propio', icon: 'ri-global-line', stepId: 7, description: 'Dominio personalizado configurado' },
  { id: 'posts', label: 'Primera publicación', icon: 'ri-file-list-3-line', stepId: 7, description: 'Al menos una publicación creada' },
  { id: 'cabina', label: 'Cabina configurada', icon: 'ri-chat-3-line', stepId: 5, description: 'Moderación activada y configurada' },
];

export const socialPlatformsList = [
  { id: 'facebook', platform: 'Facebook', icon: 'ri-facebook-fill', placeholder: 'https://facebook.com/turadio' },
  { id: 'instagram', platform: 'Instagram', icon: 'ri-instagram-fill', placeholder: 'https://instagram.com/turadio' },
  { id: 'twitter', platform: 'X (Twitter)', icon: 'ri-twitter-x-fill', placeholder: 'https://x.com/turadio' },
  { id: 'youtube', platform: 'YouTube', icon: 'ri-youtube-fill', placeholder: 'https://youtube.com/@turadio' },
  { id: 'tiktok', platform: 'TikTok', icon: 'ri-tiktok-fill', placeholder: 'https://tiktok.com/@turadio' },
  { id: 'whatsapp', platform: 'WhatsApp', icon: 'ri-whatsapp-fill', placeholder: 'https://wa.me/521234567890' },
  { id: 'spotify', platform: 'Spotify', icon: 'ri-spotify-fill', placeholder: 'https://open.spotify.com/show/turadio' },
  { id: 'discord', platform: 'Discord', icon: 'ri-discord-fill', placeholder: 'https://discord.gg/turadio' },
  { id: 'twitch', platform: 'Twitch', icon: 'ri-twitch-fill', placeholder: 'https://twitch.tv/turadio' },
  { id: 'telegram', platform: 'Telegram', icon: 'ri-telegram-fill', placeholder: 'https://t.me/turadio' },
];

export const weekDays = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábados', 'Domingos'];

export const scheduleTemplates = [
  { day: 'Lunes - Viernes', timeRange: '06:00 - 10:00', program: '', host: '' },
  { day: 'Lunes - Viernes', timeRange: '10:00 - 14:00', program: '', host: '' },
  { day: 'Lunes - Viernes', timeRange: '14:00 - 18:00', program: '', host: '' },
  { day: 'Lunes - Viernes', timeRange: '18:00 - 22:00', program: '', host: '' },
];

export const onboardingCategories = [
  'Música Latina', 'Pop', 'Rock', 'Electrónica', 'Reggaetón', 'Regional Mexicana',
  'Jazz & Blues', 'Clásica', 'Noticias', 'Deportes', 'Talk Show', 'Religiosa',
  'Comunitaria', 'Cultural', 'Podcast', 'Variada',
];

export const onboardingCountries = [
  'Argentina', 'Bolivia', 'Brasil', 'Chile', 'Colombia', 'Costa Rica',
  'Cuba', 'Ecuador', 'El Salvador', 'España', 'Guatemala', 'Honduras',
  'México', 'Nicaragua', 'Panamá', 'Paraguay', 'Perú', 'República Dominicana',
  'Uruguay', 'Venezuela', 'Estados Unidos', 'Otro',
];